// extracted by mini-css-extract-plugin
module.exports = {"scroll":"seo-table_scroll___Wpuo","heading":"seo-table_heading__IRoQj","table":"seo-table_table__gOYTG"};